var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4823_18961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4823_18961)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1621 1.90491H18.9324C18.6461 1.90491 18.3998 1.72313 18.3423 1.47029C18.1192 0.488484 17.1553 -0.250026 16 -0.250026C14.8447 -0.250026 13.8808 0.488484 13.6577 1.47022C13.6002 1.72307 13.354 1.90484 13.0676 1.90484H9.83795C9.12305 1.90484 8.53139 2.38061 8.43152 2.99998H6.28887C4.47247 2.99998 3 4.46877 3 6.28062V28.9694C3 30.7812 4.47247 32.25 6.28887 32.25H25.7112C27.5275 32.25 29 30.7812 29 28.9694V6.28062C29 4.46877 27.5275 2.99998 25.7112 2.99998H23.5685C23.4686 2.38059 22.877 1.90491 22.1621 1.90491ZM7.41168 6.24998H24.5883C25.2299 6.24998 25.75 6.77442 25.75 7.42139V27.8286C25.75 28.4756 25.23 29 24.5884 29H7.41168C6.77016 29 6.25002 28.4756 6.25002 27.8286V7.42139C6.25002 6.77449 6.7701 6.24998 7.41168 6.24998Z",
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6709,
    y: 9.49678,
    width: 14.6581,
    height: 2.47742,
    rx: 1.23871,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6709,
    y: 13.8323,
    width: 14.6581,
    height: 2.47742,
    rx: 1.23871,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6709,
    y: 18.1677,
    width: 14.6581,
    height: 2.47742,
    rx: 1.23871,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6709,
    y: 22.5032,
    width: 10.1161,
    height: 2.47742,
    rx: 1.23871,
    fill: "#4674B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.474c0cd5d5b9ada2075b032d480ef222.svg";
export { ForwardRef as ReactComponent };